document.addEventListener('DOMContentLoaded', function() {
  
  const observerOptions = {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  const elementsToAnimate = document.querySelectorAll(
    '.scroll-fade, ' +
    '.scroll-fade-up, ' +
    '.scroll-fade-left, ' +
    '.scroll-fade-right, ' +
    '.scroll-scale'
  );

  elementsToAnimate.forEach(element => {
    observer.observe(element);
  });
});


